import { useEffect, useState, useRef } from "react";

// Si no hay segundos o es 0 o negativo, no cuenta nada (null evita mostrar "0")
const startValue = (seconds) => (seconds > 0 ? seconds : null);

export function useCustomCountdown(seconds, onCompleted) {
  const [current, setCurrent] = useState(() => startValue(seconds));
  const [countFor, setCountFor] = useState(seconds);
  const intervalRef = useRef(null);

  // Otra cantidad de segundos reinicia la cuenta.
  if (seconds !== countFor) {
    setCountFor(seconds);
    setCurrent(startValue(seconds));
  }

  useEffect(() => {
    if (startValue(seconds) === null) return;

    intervalRef.current = setInterval(() => {
      setCurrent((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          onCompleted && onCompleted();
          return null; // evita mostrar "0"
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds]);

  return current;
}
